export const QA_NAME_REQUEST_PROFILE_TAB_EMAILS_ADD_BUTTON =
  'requestProfileTabEmailsAddButton'

export const EMAIL_RECIPIENT_TYPE_APPLICANT = 'applicant'

export const EMAIL_RECIPIENT_TYPE_PROVIDERS = 'providers'

export const EMAIL_RECIPIENT_TYPE_OTHERS = 'others'

export const EMAIL_ADD_BUTTON_OPTIONS = [
  {
    label: 'RequestProfile.AddEmailToApplicantKey',
    value: EMAIL_RECIPIENT_TYPE_APPLICANT,
  },
  {
    label: 'RequestProfile.AddEmailToProvidersKey',
    value: EMAIL_RECIPIENT_TYPE_PROVIDERS,
  },
  {
    label: 'RequestProfile.AddEmailToOthersKey',
    value: EMAIL_RECIPIENT_TYPE_OTHERS,
  },
]

export const EMAIL_AUDIENCE_BY_RECIPIENT_TYPE = {
  [EMAIL_RECIPIENT_TYPE_APPLICANT]: 'dwellers',
  [EMAIL_RECIPIENT_TYPE_OTHERS]: 'managers',
  [EMAIL_RECIPIENT_TYPE_PROVIDERS]: 'providers',
}
